import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const LoadingPage = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 10000); // Adjust this time as needed

    return () => clearTimeout(timer);
  }, []);

  return (
    <AnimatePresence>
      {loading && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 flex items-center justify-center bg-gradient-to-r from-green-700 to-indigo-300"
        >
          <div className="relative">
            <motion.div
              animate={{
                scale: [1, 1.2, 1],
                rotate: [0, 360],
              }}
              transition={{
                duration: 2,
                ease: "easeInOut",
                times: [0, 0.5, 1],
                repeat: Infinity,
              }}
              className="absolute inset-0 rounded-full bg-white opacity-20"
            />
            <motion.div
              animate={{
                scale: [1, 1.5, 1],
                rotate: [0, -360],
              }}
              transition={{
                duration: 2,
                ease: "easeInOut",
                times: [0, 0.5, 1],
                repeat: Infinity,
                delay: 0.2,
              }}
              className="absolute inset-0 rounded-full bg-white opacity-10"
            />
            <img
              src="/Images/logo.png" // Use a standard img tag
              alt="App Logo"
              width={150}
              height={150}
              className="relative z-10"
            />
          </div>
          <motion.div
            className="absolute bottom-10 left-0 right-0 text-center text-white text-2xl font-bold"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.5 }}
          >
            Loading your future...
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default LoadingPage;